module.exports = __webpack_public_path__ + "img/l.0c8e69dd.png";